import stateMachine from "../instances/state_machine"
import {MixinStateMachine} from "../../../lib/mixins/stateable";

export default class NavBase {

    constructor(props={}) {
        console.log(`[Nav] Initialization properties:`,props);

        this.win = (props.hasOwnProperty('window') ? props.window : null);
        this.doc = (props.hasOwnProperty('document') ? props.document : null);

        MixinStateMachine(this); // Add the state machine management methods to `this`.
        this.setStateMachine(stateMachine);
        this.setStateableObject(this); // Set the stateable object on the state machine to this Nav instance.
    }

}